import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { BankListStoreContext } from "@src/components/modules/bank";
import {
  FormRow,
  InputDatePicker,
  NumberInput,
  Select,
  TextField,
} from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import { useContext } from "react";

export const AddManualMoveModal = observer(function AddManualMoveModal() {
  const { addManualMoveModalStore: store, pagination } =
    useContext(BankListStoreContext);

  return (
    <Modal
      isCentered
      isOpen={store.disclosure.isOpen}
      onClose={store.disclosure.onClose}
      scrollBehavior="inside"
      trapFocus={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Trans>Add bank move manually</Trans>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <FormRow title={t`Currency`}>
            <Select
              asPortal
              options={store.currencyOptions}
              value={store.form.$.currencyId.value}
              onChange={store.form.$.currencyId.onChange}
              error={store.form.$.currencyId.error}
            />
          </FormRow>
          <FormRow title={t`Amount`}>
            <NumberInput
              value={store.form.$.amount.value}
              currency
              onChange={store.form.$.amount.onChange}
              error={store.form.$.amount.error}
              suffix={store.selectedCurrency?.code}
              decimalDigits={2}
            />
          </FormRow>
          <FormRow title={t`Date`}>
            <InputDatePicker
              onChange={store.handleSelectDate}
              selected={store.form.$.date.value}
              error={store.form.$.currencyId.error}
            />
          </FormRow>
          <FormRow title={t`Bank account`}>
            <Select
              asPortal
              options={store.bankAccountOptions}
              value={store.form.$.bankAccountId.value}
              onChange={store.form.$.bankAccountId.onChange}
              error={store.form.$.bankAccountId.error}
            />
          </FormRow>
          <FormRow title={t`Note`}>
            <TextField
              value={store.form.$.note.value}
              onChange={store.form.$.note.onChange}
              error={store.form.$.note.error}
            />
          </FormRow>
        </ModalBody>
        <ModalFooter>
          <HStack justify="end" spacing="2">
            <Button
              colorScheme="grey"
              isLoading={store.mutator.isLoading.value}
              onClick={store.disclosure.onClose}
              variant="outline"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              isLoading={store.mutator.isLoading.value}
              onClick={async () => {
                const success = await store.handleConfirm();
                if (!success) return;
                pagination.resetPage();
              }}
            >
              <Trans>Confirm</Trans>
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
